import { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "utils/@reduxjs/toolkit";
import { placeCreatedRowFirst } from "utils/helpers";
import { initialState } from "./initialState";
import { formState, formTableRow } from "../types";
export const sliceKey = "formsState";

export const formsSlice = createSlice({
      name: sliceKey,
      initialState: initialState,
      reducers: {
            getFormsList: (state)=>{
                  state.loading = true
            },
            FormsLisStucsses: (state, action: PayloadAction<formTableRow[]>)=>{
                  state.loading = false
                  state.formData = action.payload
            },

            getFormsListFailer: (state)=>{
                  state.loading = false
            },

            updateForm: (state, action: PayloadAction<formState>)=>{
                  state.loading = false
                  state.formState = action.payload
            },

            setFormField: (state, action: PayloadAction<{ name: keyof formState; value: string }>)=>{
                  state.formState = { ...state.formState, [action.payload.name]: action.payload.value }
            },


            resetForm: (state)=>{
                  state.loading = false
                  state.formState = {
                  fileName:"",
                  formDesc:"",
                  formGroup:0,
                  sortorder:0,
            }
                  state.uploadedFile = null
                  state.uploadedFileError = ""
            },

            setUploadedFile: (state, action: PayloadAction<{ name: string; url: string } | null>)=>{
                  state.uploadedFile = action.payload
                  state.uploadedFileError = ""
            },

            setUploadedFileError: (state, action: PayloadAction<string>)=>{
                  state.uploadedFileError = action.payload
            },

            craeteForm: (state, action: PayloadAction<formState>)=>{
                  state.loading = true
                  state.pendingForm = action.payload
            },

            craeteFormSucsses: (state, action: PayloadAction<formTableRow>)=>{
                  state.loading = false
                  state.formData = placeCreatedRowFirst(state.formData, action.payload)
            },
            createFormFailer: (state)=>{
                  state.loading = false
            },

            openAddModal: (state)=>{
                  state.isAddModalOpen = true
                  state.uploadedFile = null
                  state.uploadedFileError = ""
            },

            closeAddModal: (state)=>{
                  state.isAddModalOpen = false
                  state.uploadedFile = null
                  state.uploadedFileError = ""
            },
      }
})

export const { reducer, actions } = formsSlice